import { ShieldCheck } from 'lucide-react';
import { useTranslation } from '@aimsos/i18n';

import MemberMfaCard from '../components/member-tabs/MemberMfaCard';
import MemberSessionsCard from '../components/member-tabs/MemberSessionsCard';
import MemberTabGuard from '../components/member-tabs/MemberTabGuard';
import { MEMBER_STATUS } from '../constants/copy';
import { useMemberSecurity } from '../hooks/useMemberSecurity';

/**
 * Security tab of the member detail: MFA enrollment (with the reminder for an active member who
 * has not enrolled) and the active sessions.
 *
 * @param {object} props
 * @param {object} props.member UI member (see `mapApiMemberToUi`)
 */
function MemberSecurityTab({ member }) {
  const { i18n } = useTranslation('people-access');
  const { mfa, sessions, isLoading, error, sendReminder, reload } = useMemberSecurity(member);

  return (
    <MemberTabGuard
      tabId="security"
      icon={ShieldCheck}
      isRemoved={member.status === MEMBER_STATUS.REMOVED}
      isLoading={isLoading}
      error={error}
      onRetry={reload}
    >
      <div className="flex flex-col gap-4">
        {mfa ? (
          <MemberMfaCard
            mfa={mfa}
            locale={i18n.language}
            canRemind={member.status === MEMBER_STATUS.ACTIVE}
            onRemind={sendReminder}
          />
        ) : null}
        <MemberSessionsCard sessions={sessions} />
      </div>
    </MemberTabGuard>
  );
}

export default MemberSecurityTab;
